import React from 'react';

import ApproversTable from '../user/ApproversTable';

import Button from 'CommonComponents/Button';
import FormTextRow from 'CommonComponents/FormTextRow';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function PositionFundApprovalsViewModal(props) {
    const close = () => {
        props.closeHandler();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title="Position Fund Approval Details" close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {Object.keys(props.pfa).length > 0 && (
                            <div className="modal__form-container">
                                <FormTextRow label="Department:" text={props.pfa.position.department ? props.pfa.position.department.name : '-'}></FormTextRow>

                                <FormTextRow label="Costcenter:" text={props.pfa.position.costcenter ? props.pfa.position.costcenter.name : '-'}></FormTextRow>

                                <FormTextRow label="Rate:" text={props.pfa.amount_data.rate}></FormTextRow>

                                <FormTextRow label="Start date:" text={props.pfa.amount_data.start_date}></FormTextRow>

                                <FormTextRow label="End date:" text={props.pfa.amount_data.end_date}></FormTextRow>

                                <FormTextRow label="Status:" text={props.pfa.canceled_at ? 'Canceled' : props.pfa.status}></FormTextRow>

                                <div className="table__card">
                                    <ApproversTable
                                        approvers={props.pfa.approvers || []}
                                        status={props.pfa.status}
                                        displayApprovalStatuses={props.displayApprovalStatuses}
                                    />
                                </div>

                                <div className="modal__footer">
                                    <Button variant="secondary" onClick={close}>
                                        Close
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
